export default __webpack_public_path__ + "static/media/ico_phone.ba140a73.svg";